var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3454 1.6929H13.2541V0.859375C13.2541 0.384705 12.8694 0 12.3947 0H5.634C5.15933 0 4.77463 0.384705 4.77463 0.859375V1.6929H2.68359C1.49893 1.6929 0.535156 2.65668 0.535156 3.84134V19.8516C0.535156 21.0362 1.49893 22 2.68359 22H15.3454C16.5301 22 17.4939 21.0362 17.4939 19.8516V3.84134C17.4939 2.65668 16.5299 1.6929 15.3454 1.6929ZM11.5353 1.71875V3.38597H6.49321C6.49321 2.81479 6.49321 2.34297 6.49321 1.71875H11.5353ZM15.7751 19.8516C15.7751 20.0886 15.5823 20.2812 15.3454 20.2812H2.68359C2.44659 20.2812 2.25391 20.0886 2.25391 19.8516V3.84134C2.25391 3.60451 2.44659 3.41165 2.68359 3.41165H4.77446V4.24535C4.77446 4.72002 5.15933 5.10472 5.63383 5.10472H12.3947C12.8692 5.10472 13.2541 4.72002 13.2541 4.24535V3.41165H15.3454C15.5823 3.41165 15.7751 3.60451 15.7751 3.84134V19.8516ZM13.0021 10.034C13.3378 10.3697 13.3378 10.9139 13.0021 11.2494L8.48605 15.7655C8.15053 16.1012 7.60637 16.1012 7.27068 15.7655L5.0264 13.5212C4.69087 13.1857 4.69087 12.6415 5.0264 12.3058C5.36209 11.9703 5.90608 11.9703 6.24178 12.3058L7.87845 13.9425L11.7868 10.0342C12.1225 9.69852 12.6664 9.69852 13.0021 10.034Z",
    fill: "#D4D1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTask);
export default __webpack_public_path__ + "static/media/iconTask.5f8572a0e23892fe622af3c0f7f1c0b4.svg";
export { ForwardRef as ReactComponent };